import { TileLayer, useMap } from 'react-leaflet';
import { useEffect } from 'react';

// CartoDB Voyager — single combined tile layer for maximum performance
const TILE_URL = 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
const TILE_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>';

export function VectorTileLayer() {
  return (
    <TileLayer
      url={TILE_URL}
      attribution={TILE_ATTRIBUTION}
      maxZoom={18}
      maxNativeZoom={18}
      subdomains="abcd"
    />
  );
}
